interface ResultBlockProps {
  content: {
    title?: string;
    showDivider?: boolean;
    statements?: string[];
  };
}

export function ResultBlock({ content }: ResultBlockProps) {
  return (
    <section className="mx-auto max-w-[1200px] px-6 py-16">
      {content.showDivider && (
        <div className="mb-12 h-px w-16 bg-border" />
      )}
      {content.title && (
        <h2 className="font-serif text-2xl md:text-3xl text-foreground mb-8">
          {content.title}
        </h2>
      )}
      {content.statements && content.statements.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-[900px]">
          {content.statements.map((statement, i) => (
            <div key={i} className="border border-border bg-background p-5">
              <p className="font-sans text-sm leading-relaxed text-foreground">
                {statement}
              </p>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
